import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "Service Desk",
            key: "cases",
            icon: <Icon fontSize="medium">support_agent_outlined</Icon>,
            route: "/servicedesk/cases",
            privacy: "private",
        },
    ];
};

export default menus;